export const ChargeCardError = {
    "INVALID_COUPON_ERROR": "invalid_coupon_error",
    "INVALID_BUSINESS_RESERVATION_ERROR": "invalid_business_reservation_error"
}